exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .btn_secondary {\n  white-space: nowrap;\n  margin: auto;\n  min-width: 75px;\n  min-height: 30px;\n  line-height: 1.5em;\n  font-size: 14px;\n  margin: auto;\n  margin-top: 3px;\n  margin-right: 0;\n}\n:host-context(.bl) .btn_secondary {\n  margin-left: 10px;\n}\n.itemcode {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.itemcode > p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-button-render.component.css
// module id = ../../../../../src/app/render/grid-button-render.component.css
// module chunks = main